var _require = require('./utxo-key'),
  UTXO_KEY_BYTE_LENGTH = _require.UTXO_KEY_BYTE_LENGTH;
function normalizeSearchQuery() {
  var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(raw || '').trim();
}
function decodedByteLength(app, value) {
  if (!value) {
    return 0;
  }
  if (/^[0-9a-fA-F]+$/.test(value)) {
    if (value.length % 2 !== 0) {
      return 0;
    }
    return value.length / 2;
  }
  try {
    var _app$crypto;
    if (app !== null && app !== void 0 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.fromBase58) {
      var hex = app.crypto.fromBase58(value);
      if (hex && hex.length % 2 === 0) {
        return hex.length / 2;
      }
    }
  } catch (err) {
    // not base58
  }
  return 0;
}
function classifyBlockIdentifier(app) {
  var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var query = normalizeSearchQuery(raw);
  if (!query) {
    return null;
  }
  var byteLength = decodedByteLength(app, query);
  if (byteLength === 32) {
    return {
      type: 'hash',
      value: query
    };
  }
  if (/^[0-9]+$/.test(query)) {
    return {
      type: 'block_id',
      value: query
    };
  }
  return {
    type: 'hash',
    value: query
  };
}
function blockLookupArgument(app) {
  var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var classified = classifyBlockIdentifier(app, raw);
  if (!classified) {
    return null;
  }
  if (classified.type === 'block_id') {
    return BigInt(classified.value);
  }
  return classified.value;
}
function classifySearchQuery(app) {
  var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var query = normalizeSearchQuery(raw);
  if (!query) {
    return null;
  }
  var byteLength = decodedByteLength(app, query);
  if (byteLength === 64) {
    return {
      type: 'transaction',
      value: query.toLowerCase()
    };
  }
  if (byteLength === 33) {
    return {
      type: 'address',
      value: query
    };
  }
  if (byteLength === 32) {
    return {
      type: 'block',
      value: query
    };
  }
  if (byteLength === UTXO_KEY_BYTE_LENGTH) {
    return {
      type: 'utxo',
      value: query
    };
  }
  if (/^[0-9]+$/.test(query)) {
    return {
      type: 'block',
      value: query
    };
  }
  return null;
}
module.exports = {
  normalizeSearchQuery: normalizeSearchQuery,
  classifySearchQuery: classifySearchQuery,
  classifyBlockIdentifier: classifyBlockIdentifier,
  blockLookupArgument: blockLookupArgument,
  decodedByteLength: decodedByteLength
};